import { FaFacebook, FaInstagram, FaYoutube, FaWhatsapp } from 'react-icons/fa';

export const socialLinks = [
  { 
    name: 'Facebook', 
    icon: FaFacebook, 
    url: process.env.REACT_APP_FACEBOOK_URL || 'https://facebook.com/profile.php?id=61577361556731?', 

    color: '#1877F2',
    hoverColor: '#0C63D4'
  },
  { 
    name: 'Instagram', 
    icon: FaInstagram, 
    url: process.env.REACT_APP_INSTAGRAM_URL || 'https://instagram.com/sbsinstitute01', 
    color: '#E4405F',
    hoverColor: '#D62954'
  },
  { 
    name: 'YouTube', 
    icon: FaYoutube, 
    url: process.env.REACT_APP_YOUTUBE_URL || 'https://youtube.com/@asadsiddiqui8860?', 
    color: '#FF0000',
    hoverColor: '#CC0000'
  },
  { 
    name: 'WhatsApp', 
    icon: FaWhatsapp, 
    url: `https://wa.me/${process.env.REACT_APP_WHATSAPP_NUMBER || '917417652434'}?text=${encodeURIComponent(process.env.REACT_APP_WHATSAPP_MESSAGE || 'Hello, I want to join SBS Institute of Coaching')}`, 
    color: '#25D366',
    hoverColor: '#1EBE57'
  },
];

export default function SocialLinks({ size = 18, variant = 'default', className = '' }) {
  const getStyles = () => {
    switch (variant) {
      case 'footer':
        return {
          container: { display: 'flex', gap: '0.8rem' },
          link: {
            background: '#1F2937',
            color: '#9CA3AF',
            width: 38,
            height: 38,
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s ease',
            cursor: 'pointer',
            border: '1px solid #374151',
          }
        };
      case 'contact':
        return {
          container: { display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' },
          link: {
            background: 'var(--white)',
            color: 'var(--gray)',
            width: 44,
            height: 44,
            borderRadius: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s ease',
            cursor: 'pointer',
            border: '2px solid var(--border)',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
          }
        };
      default:
        return {
          container: { display: 'flex', gap: '0.6rem' },
          link: {
            background: 'var(--white)',
            color: 'var(--gray)',
            width: 36,
            height: 36,
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s ease',
            cursor: 'pointer',
            border: '1px solid var(--border)',
          }
        };
    }
  };

  const styles = getStyles();

  return (
    <div style={styles.container} className={className}>
      {socialLinks.map(({ name, icon: Icon, url, color }) => (
        <a
          key={name}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={name}
          style={styles.link}
          onMouseEnter={e => {
            e.currentTarget.style.background = color;
            e.currentTarget.style.color = '#fff';
            e.currentTarget.style.transform = 'translateY(-3px)';
            e.currentTarget.style.borderColor = color;
            e.currentTarget.style.boxShadow = `0 6px 20px ${color}40`;
          }}
          onMouseLeave={e => {
            e.currentTarget.style.background = styles.link.background;
            e.currentTarget.style.color = styles.link.color;
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.borderColor = styles.link.border?.split(' ')[2] || 'transparent';
            e.currentTarget.style.boxShadow = styles.link.boxShadow || 'none';
          }}
        >
          <Icon size={size} />
        </a>
      ))}
    </div>
  );
}
